import type { ReactNode } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../Button/Button'
import Typography from '../Typography/Typography'
import { ActionTypes } from './Actions'
import type { TableRow } from './TableContext'
import { useTable } from './TableContext'

interface BulkActionProps {
  children: ReactNode | ((selected: TableRow[]) => ReactNode) | undefined
}

function BulkActions({ children }: BulkActionProps): JSX.Element {
  const [state, dispatch] = useTable()
  const selectedRows = state.rows.filter((row) => row.selected)
  const numberSelected = selectedRows.length

  const handleChange = (toggled: boolean) => {
    const status = toggled ? 'checked' : 'unchecked'

    dispatch({
      type: ActionTypes.ToggleRows,
      status,
      selectionsRef: state.selectionsRef,
    })
  }

  return (
    <div className="flex items-center py-px">
      <Typography component="p" variant="subtitle2">
        <FormattedMessage
          id="Ui.number_selected"
          values={{ number: numberSelected }}
        />
      </Typography>
      <div className="ml-6 items-center flex space-x-3">
        <Button
          onClick={() => {
            handleChange(false)
          }}
          variant="contained"
        >
          <FormattedMessage id="Table.clear_selection" />
        </Button>
        {!state.allSelected ? (
          <Button
            onClick={() => {
              handleChange(true)
            }}
            variant="contained"
          >
            <FormattedMessage
              id="Table.select_all_n"
              values={{ count: state.rows.length }}
            />
          </Button>
        ) : null}
        {typeof children === 'function' ? children(selectedRows) : children}
      </div>
    </div>
  )
}

export default BulkActions
